module.exports = __webpack_public_path__ + "img/mi-list.c5d947f8.svg";